import type { Subscription } from '@/features/subscriptions/types/subscriptions/subscription.types'

export const mockPlanSubscriptions: Subscription[] = [
  {
    id: 'sub-1',
    customer: 'Acme Corp',
    customerId: 'cust_001',
    status: 'active',
    plan: 'Enterprise Plan',
    planId: 'plan_001',
    product: 'product_name',
    avgMonthly: '€299.00/monthly',
    avgYearly: '€3,588.00/yearly',
    created: '2025-01-15',
  },
  {
    id: 'sub-2',
    customer: 'TechStart Inc',
    customerId: 'cust_002',
    status: 'active',
    plan: 'Pro Plan',
    planId: 'plan_001',
    product: 'product_name',
    avgMonthly: '€0.00/monthly',
    avgYearly: '€0.00/yearly',
    created: '2025-02-01',
  },
  {
    id: 'sub-3',
    customer: 'Local Business',
    customerId: 'cust_003',
    status: 'active',
    plan: 'Standard Plan',
    planId: 'plan_001',
    product: 'product_name',
    avgMonthly: '€149.00/monthly',
    avgYearly: '€1,788.00/yearly',
    created: '2024-12-01',
  },
  {
    id: 'sub-4',
    customer: 'Global Services',
    customerId: 'cust_004',
    status: 'cancelled',
    plan: 'Premium Plan',
    planId: 'plan_002',
    product: 'product_name',
    avgMonthly: '€199.00/monthly',
    avgYearly: '€2,388.00/yearly',
    created: '2024-06-01',
  },
]
